module.exports = {
      id: "bookmark-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#bookmark",
      toString: function () {
        return this.url;
      }
    }